/*
 * Eldstad footer (sections/eldstad-footer.liquid).
 *
 * 1. Phones: the link columns start closed, as accordions. Wider: always open.
 * 2. The chat lift. Weply draws its bubble in a fixed iframe at the bottom right.
 *    As the footer scrolls into view, the bubble moves up with it and rests GAP px
 *    above the footer's top edge, so it never covers footer links. While the chat
 *    window is open the lift is off, because the window grows (full screen on phones).
 *    Weply's public API (window.weplyWidgetReady) tells us open and closed; a tall
 *    iframe is treated as open too, in case the API arrives late.
 * 3. "Chatta med oss" opens the chat through the same API, or follows its link.
 */
(function () {
  var footer = document.querySelector('[data-eldstad-footer]');
  if (!footer) return;

  var GAP = 16;
  var root = document.documentElement;
  var api = null;
  var chatOpen = false;
  var raf = 0;

  function frame() {
    return document.querySelector('iframe[title="Weply chat"]');
  }

  // Without the API we guess "open" from size. The greeting bubble makes the
  // minimised frame about 200 px tall; the open window takes most of the screen.
  function looksOpen(f) {
    return !api && f.getBoundingClientRect().height > Math.max(360, window.innerHeight * 0.5);
  }

  // Computed even while Weply keeps the frame hidden, so it is already in place
  // the moment it becomes visible and never shows at its default spot first.
  function lift() {
    raf = 0;
    var f = frame();
    var value = 0;
    if (f && !chatOpen && !looksOpen(f)) {
      var base = parseFloat(getComputedStyle(f).bottom) || 0;
      var onScreen = Math.max(0, window.innerHeight - footer.getBoundingClientRect().top);
      value = Math.max(0, onScreen - base + GAP);
    }
    root.style.setProperty('--eldstad-chat-lift', value + 'px');
  }

  function queue() {
    if (!raf) raf = requestAnimationFrame(lift);
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  window.addEventListener('pageshow', queue);

  // Weply adds its frame after load, may replace it, and changes its inline
  // style (position, height, visibility) as the widget changes state. Watch all
  // three; none of them fires a scroll.
  var watched = null;
  var styleObserver = new MutationObserver(queue);
  var sizeObserver = 'ResizeObserver' in window ? new ResizeObserver(queue) : null;
  function watch() {
    var f = frame();
    if (f && f !== watched) {
      if (watched) {
        styleObserver.disconnect();
        if (sizeObserver) sizeObserver.unobserve(watched);
      }
      styleObserver.observe(f, { attributes: true, attributeFilter: ['style'] });
      if (sizeObserver) sizeObserver.observe(f);
      watched = f;
    }
    queue();
  }
  new MutationObserver(watch).observe(document.body, { childList: true });
  watch();

  // Weply's public API. Keep any handler that was set before ours.
  function attach(publicApi) {
    if (!publicApi || api) return;
    api = publicApi;
    try { chatOpen = api.widget.isMinimized() === false; } catch (e) {}
    api.widget.on('maximize', function () { chatOpen = true; queue(); });
    api.widget.on('minimize', function () { chatOpen = false; queue(); });
    var status = footer.querySelector('[data-eldstad-chat-status]');
    if (status && api.widget.hasOnlineAgents) {
      api.widget.hasOnlineAgents().then(function (online) {
        status.textContent = online ? 'Vi har någon online' : 'Lämna ett meddelande';
        status.classList.toggle('is-online', online);
      }).catch(function () {});
    }
    queue();
  }
  var previous = window.weplyWidgetReady;
  window.weplyWidgetReady = function (publicApi) {
    if (typeof previous === 'function') previous(publicApi);
    attach(publicApi);
  };
  if (window.$$weply && window.$$weply.api && window.$$weply.api.publicApi) {
    attach(window.$$weply.api.publicApi);
  }

  footer.querySelectorAll('[data-eldstad-chat-open]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (!api || !api.widget.maximize) return; // no chat on this page: follow the link
      event.preventDefault();
      api.widget.maximize();
    });
  });

  // Accordions: closed on phones, open on wider screens.
  var phone = window.matchMedia('(max-width: 600px)');
  function syncColumns() {
    footer.querySelectorAll('.eldstad-footer__col').forEach(function (d) { d.open = !phone.matches; });
  }
  if (phone.addEventListener) phone.addEventListener('change', syncColumns);
  syncColumns();

  queue();
})();
